<template>
  <ValidationObserver v-slot="{ invalid }">
    <form class="chi-form" @submit.prevent="onSubmit">
      <h2>Account Information</h2>
      <div
        class="w-full my-5 p-3 border border-purple-ap-t03 rounded bg-gray-200"
      >
        <p class="text-center">
          Your email/username is:
          <span class="font-semibold">{{ user.email }} </span>
        </p>
      </div>

      <div class="-mx-3 md:flex">
        <!-- first name -->
        <div class="md:w-1/2 px-3 mb-3">
          <ChiInput
            type="text"
            rules="required|alpha_spaces"
            name="first name"
            label="First Name"
            placeholder="Your First Name"
            v-model="user.firstName"
          />
        </div>

        <!-- last name -->
        <div class="md:w-1/2 px-3 mb-3">
          <ChiInput
            type="text"
            rules="required|alpha_spaces"
            name="last name"
            label="Last Name"
            placeholder="Your Last Name"
            v-model="user.lastName"
          />
        </div>
      </div>

      <div class="-mx-3 md:flex mb-6">
        <!-- phone -->
        <div class="md:w-1/2 px-3 mb-6 md:mb-0">
          <ChiInput
            type="tel"
            rules="digits:10"
            name="phone"
            label="Phone"
            optional="true"
            placeholder="Your Phone"
            v-model="user.phone"
            maxlength="10"
          />
        </div>

        <!-- no of children -->
        <div class="md:w-1/2 px-3 mb-6 md:mb-0">
          <ChiInput
            type="number"
            rules="required|min_value:1"
            name="number of children"
            label="How many children would need childcare?"
            placeholder="Number of children"
            v-model="user.hasChildrenOrPlanTo"
            maxlength="2"
            min="1"
          />
        </div>
      </div>

      <div class="mt-3 mb-8 text-center">
        <button
          @click.prevent="changePass()"
          class="cursor-pointer text-purple-ap-100 hover:text-purple-ap-200"
        >
          <i class="material-icons align-text-bottom">lock</i> Would you like to
          change your password?
        </button>
      </div>

      <fieldset v-if="changingPass">
        <h2>Change your Password</h2>
        <!-- password -->
        <div class="-mx-3 md:flex mb-6">
          <!-- pass -->

          <div class="md:w-1/2 px-3 mb-6 md:mb-0">
            <ChiInput
              type="password"
              rules="required|passwordPolicy"
              name="password"
              label="Your new password"
              placeholder="Type your new password"
              v-model="user.password"
            />
          </div>
          <!-- confirmation -->
          <div class="md:w-1/2 px-3 mb-6 md:mb-0">
            <ChiInput
              type="password"
              rules="required|passwordCheck:@password"
              name="confirmation"
              label="Password confirmation"
              placeholder="Type your new password"
              v-model="user.confirmPassword"
            />
          </div>
        </div>
      </fieldset>

      <fieldset>
        <h2>Address</h2>
        <div class="-mx-3 md:flex mb-6">
          <!-- city -->
          <div class="md:w-1/2 px-3 mb-6 md:mb-0">
            <ChiInput
              type="text"
              rules="required|alpha_spaces"
              name="city"
              label="City"
              placeholder="Your city"
              v-model="user.city"
            />
          </div>
          <!-- state -->
          <div class="md:w-1/2 px-3 mb-6 md:mb-0">
            <ChiInput
              type="select"
              rules="required"
              name="state"
              label="State"
              placeholder="Select your state"
              v-model="user.state"
              :options="states"
            />
          </div>
          <!-- zip -->
          <div class="md:w-1/2 px-3">
            <ChiInput
              type="text"
              rules="required|numeric"
              name="zip"
              label="Zip"
              placeholder="Your zip code"
              v-model="user.zip"
              maxlength="5"
            />
          </div>
        </div>

        <div class="-mx-3 md:flex mb-6"></div>
      </fieldset>

      <div class="-mx-3 flex items-center justify-center mb-2">
        <div v-if="!loading" class="w-full px-3">
          <input
            :disabled="invalid || disableAction"
            type="submit"
            class="btn btn-purple apply"
            value="Save Changes"
          />
        </div>
        <ComponentLoading v-else />
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
//import { mapFields } from "@/helpers.js";

import { USStates } from "@/helpers.js";
import ChiInput from "@/components/Forms/ChiInput.vue";

export default {
  name: "UserEditForm",
  components: {
    ChiInput,
  },
  data() {
    const userState = this.$store.state.user;
    return {
      user: {
        firstName: userState.firstName,
        lastName: userState.lastName,
        email: userState.email,
        phone: userState.phone,
        password: null,
        confirmPassword: null,
        city: userState.city,
        state: userState.state,
        zip: userState.zip,
        citizenOrResident: userState.citizenOrResident,
        hasChildrenOrPlanTo: userState.hasChildrenOrPlanTo,
      },
      states: USStates(),
      loading: false,
      disableAction: false,
      changingPass: false,
    };
  },
  methods: {
    onSubmit() {
      this.$emit("form-submitted", this.user);
    },
    changePass() {
      this.changingPass = !this.changingPass;
    },
  },
};
</script>
